import { EventEmitter, Injectable } from '@angular/core';
import { UserApiService } from './api/user-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  data: any = undefined;
  events = new EventEmitter<any>();
  constructor(private api: UserApiService) {}

  async getSelf() {
    if (this.data !== undefined) {
      return this.data;
    }
    try {
      const r = await this.api.getSelf();
      this.setSelf(r.data);
    } catch (error) {}
    return this.data;
  }

  setSelf(data: any) {
    this.data = data;
    this.events.emit(this.data);
  }
}
